const LOGO_PATH = '/images/logos/logo.svg';
const SMALL_LOGO_PATH = '/images/logos/logo-small.png';

export { LOGO_PATH, SMALL_LOGO_PATH };
